import React from 'react';
import GrassIcon from '@mui/icons-material/Grass';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Wheat" — used for a field season’s previous crop' },
];

const CropManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Crops"
    icon={<GrassIcon />}
    apiPath="/api/crops"
    fields={fields}
    entityLabel="Crop"
  />
);

export default CropManagement;
